import request from '@/utils/request'

/**
 * 查询服务费设置列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopServiceRule(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/rule.queryShopServiceRule',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加服务费设置
 * @param {Object} data 服务费设置数据
 * @returns {Promise} Promise对象
 */
export function saveShopServiceRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/rule.saveShopServiceRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新服务费设置
 * @param {Object} data 服务费设置数据
 * @returns {Promise} Promise对象
 */
export function updateShopServiceRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/rule.updateShopServiceRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除服务费设置
 * @param {Object} data 服务费设置数据
 * @returns {Promise} Promise对象
 */
export function deleteShopServiceRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/rule.deleteShopServiceRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
